import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import EditEntityField from "../profile/EditEntityField";
import { patchVendor } from "../../patchers/vendor";
import * as _ from "lodash";
import { toast } from "react-toastify";

import ImageUploader from "../global/ImageUploader";
import { useGetAvailableTranslation } from "../../hooks/global/Languages";
import ImageWithFallback from "../global/ImageWithFallback";

function VendorSettings({vendor, refreshVendor}) {

  const availableLan = useGetAvailableTranslation();

  const [showImageUploader, setShowImageUploader] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const [logoSrc, setLogoSrc] = useState(vendor.logo_url);

  const { t, i18n } = useTranslation();

  const uploadImage = (s) => {
    setShowSpinner(true);
    setShowImageUploader(false);
  };

  const handleUpdate = (e) => {
    setLogoSrc(e.data);
    const payload = {};
    payload["fieldName"] = "logo_url";
    payload["fieldValue"] = e.data;
    patchVendor(vendor.id, payload).then((res) => {
    });
  };

  const updateLanguages = (lng) => {
    let currentLanguages = _.cloneDeep(vendor.languages);
    currentLanguages.includes(lng)
      ? _.remove(currentLanguages, (clng) => clng === lng)
      : currentLanguages.push(lng);
    if (!currentLanguages.length) return;
    let payload = {};
    payload["fieldName"] = "languages";
    payload["fieldValue"] = currentLanguages;

    patchVendor(vendor.id, payload).then((res) => {
      refreshVendor();
      toast.success(
        `${t("toast.lad1")} ${
          vendor.languages.includes(lng) ? t("toast.lad2a") : t("toast.lad2b")
        } ${t("toast.lad3")}.`
      );
    });
  };

  const checkLngValue = (lng) => {
    return vendor.languages.includes(lng);
  };

  return (
    <div>
      <div className="editMe-field margin-bottom-40">
        <div className="artNamePreview">
          <strong>{t("admin.set.ti")}</strong>
          <em>{t("admin.set.tt")}</em>
          <EditEntityField
            fieldName="name"
            fieldValue={vendor.name}
            editType="textarea"
            showType="text"
            validations={["required"]}
            entityId={vendor.id}
            vendor={vendor}
            entityName={"vendors"}
            isMultilanguage={false}
            onSuccess={refreshVendor}
          />
        </div>
        <div className="artImgPreview">
          <div>
            <ImageWithFallback src={logoSrc} alt={t("err.noUrl")}/>
            <button
              className="btn btn-edit"
              onClick={() => setShowImageUploader(true)}
            >
              {t("admin.group.picUp")}
            </button>
          </div>
          {showSpinner && (
            <div className="artImgLoader">
              <div className="loaderAdmin">
                <div className="loader"></div>
              </div>
            </div>
          )}
        </div>
        <div className="artImgUploader artImgUploaderVendorSettings">
          <div className="artImgCTA">
            {showImageUploader && (
              <div className="artImgForm">
                <span className="closeMe" onClick={() => setShowImageUploader(false)}> Zapri </span>
                <ImageUploader index="logo_url" location={`images/merlin/vendors/${vendor.id}`} onSave={(e) => {handleUpdate(e); setShowImageUploader(false)}}/>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="editMe-field margin-bottom-40">
        <div>
          <strong>{t("admin.set.lngs")}</strong>
          {availableLan.map((lng) => {
            return (
              <div className="customCheckboxSettings" key={lng}>
                <input
                  type="checkbox"
                  id={lng + "customCheckboxSettings"}
                  checked={checkLngValue(lng)}
                  onChange={() => updateLanguages(lng)}
                />
                <label htmlFor={lng + "customCheckboxSettings"}>{lng}</label>
              </div>
            );
          })}
        </div>
      </div>
      <div className="editMe-field margin-bottom-40">
        <div className="settingsWrap">
          <strong>{t("admin.set.reviewing")}</strong>
          <div className="editMe-customCheckbox">
            <EditEntityField
              fieldName="anonymous_reviewing"
              fieldValue={vendor.anonymous_reviewing}
              fieldLabel={t("admin.set.anonymousReviewing")}
              editType="checkbox"
              showType="checkbox"
              validations={[]}
              entityId={vendor.id}
              vendor={vendor}
              entityName={"vendors"}
              onSuccess={refreshVendor}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default VendorSettings;
